import styles from "./OnboardingStyles.module.css"
import { useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import { useTranslation } from "react-i18next";
import { getOnboardingEventOptions } from "./onboardingOptions";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step3Form = ({currentStep, setStep, formData, setFormData}:StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const [chosenOptions, setChosenOptions] = useState<string[]>(formData.actionType ? formData.actionType : []) // Current chosen options
    // List with available options
    const optionList = getOnboardingEventOptions(t);
    // Handle choices
    const handleChoice = (choice: string) => {
        // Make sure 3 are selected at max
        if (chosenOptions.length < 3) { 
            setChosenOptions(prev => prev ? [...prev, choice] : [choice]);
        }
        // Handle deselect
        if(chosenOptions.includes(choice)){
            setChosenOptions(chosenOptions.filter(item => item !== choice));
        }
    };
    // Submit logic
    const handleAction = () => {
        setFormData((prev: typeof formData)=>({...prev,actionType: chosenOptions }))
        setStep(currentStep+1)
    }
    return(
        <>
        <div className={styles.OnboardingContent}>
            <div className={styles.SecondaryContainer}>
                <div className={styles.Info}>
                    <div className={styles.SecondaryTitle}>
                        <p>{t("onboarding.steps.3.title")}</p>
                    </div>
                    <div className={styles.Subtitle}>
                        <p>{t("onboarding.steps.3.subtitle")}</p>
                    </div>
                </div>
                <div className={styles.ChoiceButtons}>
                    {optionList.map(option => (
                        <SecondaryButton 
                        onClick={()=>handleChoice(option.slug)} 
                        text={option.text} key={option.slug} 
                        className={`${chosenOptions.includes(option.slug) ? `${styles.ChosenOption}` : undefined} ${styles.ChoiceButtonRound}`} 
                        showChevron={false} 
                        colorVariant="primary" 
                        disabled={chosenOptions.length >2 &&  !chosenOptions.includes(option.slug)}/>
                    ))}
                </div>
                <div  className={styles.ContinueButton}>
                    <div className={styles.ContinueChoice} onClick={()=>setStep(currentStep+1)}><p></p></div>
                    <PrimaryButton onClick={()=>handleAction()} text={t("buttons.proceed")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Step3Form;
